/* tslint:disable */
/* eslint-disable */
/**
 * Abekus Open API Docs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ClassMarksResponse } from '../models';
// @ts-ignore
import type { ClassMaterialsResponse } from '../models';
// @ts-ignore
import type { ClassQuizMarksResponse } from '../models';
// @ts-ignore
import type { ClassQuizPaperResponse } from '../models';
// @ts-ignore
import type { ClassWorkResponse } from '../models';
// @ts-ignore
import type { ErrorResponse } from '../models';
// @ts-ignore
import type { GetClassCoursesResponse } from '../models';
// @ts-ignore
import type { HandInAnswerSheetResponse } from '../models';
// @ts-ignore
import type { JoinedClassResponse } from '../models';
// @ts-ignore
import type { JoinedClassesResponse } from '../models';
// @ts-ignore
import type { MyInsightsResponse } from '../models';
// @ts-ignore
import type { PostsResponse } from '../models';
// @ts-ignore
import type { QuizAttemptQuestionResponse } from '../models';
// @ts-ignore
import type { QuizAttemptResponse } from '../models';
// @ts-ignore
import type { QuizAttemptResultResponse } from '../models';
// @ts-ignore
import type { QuizCodeRunBody } from '../models';
// @ts-ignore
import type { ReadCardBody } from '../models';
// @ts-ignore
import type { ReadCardResponse } from '../models';
// @ts-ignore
import type { RollNumberBody } from '../models';
// @ts-ignore
import type { RollNumberResponse } from '../models';
// @ts-ignore
import type { SaveAttemptAnswerBody } from '../models';
// @ts-ignore
import type { StudentCourseResponse } from '../models';
// @ts-ignore
import type { StudentCoursesResponse } from '../models';
// @ts-ignore
import type { SubmissionResponse } from '../models';
// @ts-ignore
import type { TodoResponse } from '../models';
/**
 * JoinedClassApiApi - axios parameter creator
 */
export const JoinedClassApiApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} classId 
         * @param {string} quizId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        joinedClassApiGetClassQuizAttempt: async (classId: string, quizId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'classId' is not null or undefined
            assertParamExists('joinedClassApiGetClassQuizAttempt', 'classId', classId)
            // verify required parameter 'quizId' is not null or undefined
            assertParamExists('joinedClassApiGetClassQuizAttempt', 'quizId', quizId)
            const localVarPath = `/api/v1/classes/{class_id}/quizzes/{quiz_id}/attempt`
                .replace('{class_id}', encodeURIComponent(String(classId)))
                .replace('{quiz_id}', encodeURIComponent(String(quizId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} classId 
         * @param {string} quizId 
         * @param {string} submissionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        joinedClassApiGetClassQuizCodeRun: async (classId: string, quizId: string, submissionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'classId' is not null or undefined
            assertParamExists('joinedClassApiGetClassQuizCodeRun', 'classId', classId)
            // verify required parameter 'quizId' is not null or undefined
            assertParamExists('joinedClassApiGetClassQuizCodeRun', 'quizId', quizId)
            // verify required parameter 'submissionId' is not null or undefined
            assertParamExists('joinedClassApiGetClassQuizCodeRun', 'submissionId', submissionId)
            const localVarPath = `/api/v1/classes/{class_id}/quizzes/{quiz_id}/attempt/code-runs/{submission_id}`
                .replace('{class_id}', encodeURIComponent(String(classId)))
                .replace('{quiz_id}', encodeURIComponent(String(quizId)))
                .replace('{submission_id}', encodeURIComponent(String(submissionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} classId 
         * @param {string} quizId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        joinedClassApiGetClassQuizMarks: async (classId: string, quizId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'classId' is not null or undefined
            assertParamExists('joinedClassApiGetClassQuizMarks', 'classId', classId)
            // verify required parameter 'quizId' is not null or undefined
            assertParamExists('joinedClassApiGetClassQuizMarks', 'quizId', quizId)
            const localVarPath = `/api/v1/classes/{class_id}/quizzes/{quiz_id}/marks`
                .replace('{class_id}', encodeURIComponent(String(classId)))
                .replace('{quiz_id}', encodeURIComponent(String(quizId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} classId 
         * @param {string} quizId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        joinedClassApiGetClassQuizPaper: async (classId: string, quizId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'classId' is not null or undefined
            assertParamExists('joinedClassApiGetClassQuizPaper', 'classId', classId)
            // verify required parameter 'quizId' is not null or undefined
            assertParamExists('joinedClassApiGetClassQuizPaper', 'quizId', quizId)
            const localVarPath = `/api/v1/classes/{class_id}/quizzes/{quiz_id}/paper`
                .replace('{class_id}', encodeURIComponent(String(classId)))
                .replace('{quiz_id}', encodeURIComponent(String(quizId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} classId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        joinedClassApiGetJoinedClass: async (classId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'classId' is not null or undefined
            assertParamExists('joinedClassApiGetJoinedClass', 'classId', classId)
            const localVarPath = `/api/v1/classes/{class_id}`
                .replace('{class_id}', encodeURIComponent(String(classId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} classId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        joinedClassApiGetMyClassInsights: async (classId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'classId' is not null or undefined
            assertParamExists('joinedClassApiGetMyClassInsights', 'classId', classId)
            const localVarPath = `/api/v1/classes/{class_id}/insights`
                .replace('{class_id}', encodeURIComponent(String(classId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} courseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        joinedClassApiGetMyCourse: async (courseId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'courseId' is not null or undefined
            assertParamExists('joinedClassApiGetMyCourse', 'courseId', courseId)
            const localVarPath = `/api/v1/classes/courses/{course_id}`
                .replace('{course_id}', encodeURIComponent(String(courseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} classId 
         * @param {string} quizId 
         * @param {File} answerSheet 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        joinedClassApiHandInClassQuizSheet: async (classId: string, quizId: string, answerSheet: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'classId' is not null or undefined
            assertParamExists('joinedClassApiHandInClassQuizSheet', 'classId', classId)
            // verify required parameter 'quizId' is not null or undefined
            assertParamExists('joinedClassApiHandInClassQuizSheet', 'quizId', quizId)
            // verify required parameter 'answerSheet' is not null or undefined
            assertParamExists('joinedClassApiHandInClassQuizSheet', 'answerSheet', answerSheet)
            const localVarPath = `/api/v1/classes/{class_id}/quizzes/{quiz_id}/answer-sheet`
                .replace('{class_id}', encodeURIComponent(String(classId)))
                .replace('{quiz_id}', encodeURIComponent(String(quizId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (answerSheet !== undefined) { 
                localVarFormParams.append('answer_sheet', answerSheet as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} classId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        joinedClassApiListClassMarks: async (classId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'classId' is not null or undefined
            assertParamExists('joinedClassApiListClassMarks', 'classId', classId)
            const localVarPath = `/api/v1/classes/{class_id}/marks`
                .replace('{class_id}', encodeURIComponent(String(classId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} classId 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        joinedClassApiListJoinedClassMaterials: async (classId: string, page?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'classId' is not null or undefined
            assertParamExists('joinedClassApiListJoinedClassMaterials', 'classId', classId)
            const localVarPath = `/api/v1/classes/{class_id}/materials`
                .replace('{class_id}', encodeURIComponent(String(classId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} classId 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        joinedClassApiListJoinedClassPosts: async (classId: string, page?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'classId' is not null or undefined
            assertParamExists('joinedClassApiListJoinedClassPosts', 'classId', classId)
            const localVarPath = `/api/v1/classes/{class_id}/posts`
                .replace('{class_id}', encodeURIComponent(String(classId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} classId 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {Array<JoinedClassApiListJoinedClassWorkPhasesEnum>} [phases] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        joinedClassApiListJoinedClassWork: async (classId: string, page?: number, pageSize?: number, phases?: Array<JoinedClassApiListJoinedClassWorkPhasesEnum>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'classId' is not null or undefined
            assertParamExists('joinedClassApiListJoinedClassWork', 'classId', classId)
            const localVarPath = `/api/v1/classes/{class_id}/work`
                .replace('{class_id}', encodeURIComponent(String(classId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (phases) {
                localVarQueryParameter['phases'] = phases;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        joinedClassApiListJoinedClasses: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/classes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} classId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        joinedClassApiListMyClassCourses: async (classId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'classId' is not null or undefined
            assertParamExists('joinedClassApiListMyClassCourses', 'classId', classId)
            const localVarPath = `/api/v1/classes/{class_id}/courses`
                .replace('{class_id}', encodeURIComponent(String(classId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        joinedClassApiListMyCourses: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/classes/courses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {JoinedClassApiListTodoStatusEnum} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        joinedClassApiListTodo: async (page?: number, pageSize?: number, status?: JoinedClassApiListTodoStatusEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/classes/todo`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} courseId 
         * @param {string} lessonId 
         * @param {ReadCardBody} readCardBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        joinedClassApiReadMyCourseCard: async (courseId: string, lessonId: string, readCardBody: ReadCardBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'courseId' is not null or undefined
            assertParamExists('joinedClassApiReadMyCourseCard', 'courseId', courseId)
            // verify required parameter 'lessonId' is not null or undefined
            assertParamExists('joinedClassApiReadMyCourseCard', 'lessonId', lessonId)
            // verify required parameter 'readCardBody' is not null or undefined
            assertParamExists('joinedClassApiReadMyCourseCard', 'readCardBody', readCardBody)
            const localVarPath = `/api/v1/classes/courses/{course_id}/lessons/{lesson_id}/read`
                .replace('{course_id}', encodeURIComponent(String(courseId)))
                .replace('{lesson_id}', encodeURIComponent(String(lessonId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(readCardBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} classId 
         * @param {string} questionId 
         * @param {string} quizId 
         * @param {QuizCodeRunBody} quizCodeRunBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        joinedClassApiRunClassQuizCode: async (classId: string, questionId: string, quizId: string, quizCodeRunBody: QuizCodeRunBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'classId' is not null or undefined
            assertParamExists('joinedClassApiRunClassQuizCode', 'classId', classId)
            // verify required parameter 'questionId' is not null or undefined
            assertParamExists('joinedClassApiRunClassQuizCode', 'questionId', questionId)
            // verify required parameter 'quizId' is not null or undefined
            assertParamExists('joinedClassApiRunClassQuizCode', 'quizId', quizId)
            // verify required parameter 'quizCodeRunBody' is not null or undefined
            assertParamExists('joinedClassApiRunClassQuizCode', 'quizCodeRunBody', quizCodeRunBody)
            const localVarPath = `/api/v1/classes/{class_id}/quizzes/{quiz_id}/attempt/answers/{question_id}/code-runs`
                .replace('{class_id}', encodeURIComponent(String(classId)))
                .replace('{question_id}', encodeURIComponent(String(questionId)))
                .replace('{quiz_id}', encodeURIComponent(String(quizId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(quizCodeRunBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} classId 
         * @param {string} questionId 
         * @param {string} quizId 
         * @param {SaveAttemptAnswerBody} saveAttemptAnswerBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        joinedClassApiSaveClassQuizAnswer: async (classId: string, questionId: string, quizId: string, saveAttemptAnswerBody: SaveAttemptAnswerBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'classId' is not null or undefined
            assertParamExists('joinedClassApiSaveClassQuizAnswer', 'classId', classId)
            // verify required parameter 'questionId' is not null or undefined
            assertParamExists('joinedClassApiSaveClassQuizAnswer', 'questionId', questionId)
            // verify required parameter 'quizId' is not null or undefined
            assertParamExists('joinedClassApiSaveClassQuizAnswer', 'quizId', quizId)
            // verify required parameter 'saveAttemptAnswerBody' is not null or undefined
            assertParamExists('joinedClassApiSaveClassQuizAnswer', 'saveAttemptAnswerBody', saveAttemptAnswerBody)
            const localVarPath = `/api/v1/classes/{class_id}/quizzes/{quiz_id}/attempt/answers/{question_id}`
                .replace('{class_id}', encodeURIComponent(String(classId)))
                .replace('{question_id}', encodeURIComponent(String(questionId)))
                .replace('{quiz_id}', encodeURIComponent(String(quizId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(saveAttemptAnswerBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {RollNumberBody} rollNumberBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        joinedClassApiSetRollNumber: async (rollNumberBody: RollNumberBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'rollNumberBody' is not null or undefined
            assertParamExists('joinedClassApiSetRollNumber', 'rollNumberBody', rollNumberBody)
            const localVarPath = `/api/v1/classes/roll-number`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rollNumberBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} classId 
         * @param {string} quizId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        joinedClassApiStartClassQuiz: async (classId: string, quizId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'classId' is not null or undefined
            assertParamExists('joinedClassApiStartClassQuiz', 'classId', classId)
            // verify required parameter 'quizId' is not null or undefined
            assertParamExists('joinedClassApiStartClassQuiz', 'quizId', quizId)
            const localVarPath = `/api/v1/classes/{class_id}/quizzes/{quiz_id}/attempt`
                .replace('{class_id}', encodeURIComponent(String(classId)))
                .replace('{quiz_id}', encodeURIComponent(String(quizId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} classId 
         * @param {string} quizId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        joinedClassApiSubmitClassQuiz: async (classId: string, quizId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'classId' is not null or undefined
            assertParamExists('joinedClassApiSubmitClassQuiz', 'classId', classId)
            // verify required parameter 'quizId' is not null or undefined
            assertParamExists('joinedClassApiSubmitClassQuiz', 'quizId', quizId)
            const localVarPath = `/api/v1/classes/{class_id}/quizzes/{quiz_id}/attempt/submit`
                .replace('{class_id}', encodeURIComponent(String(classId)))
                .replace('{quiz_id}', encodeURIComponent(String(quizId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * JoinedClassApiApi - functional programming interface
 */
export const JoinedClassApiApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = JoinedClassApiApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} classId 
         * @param {string} quizId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async joinedClassApiGetClassQuizAttempt(classId: string, quizId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuizAttemptResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.joinedClassApiGetClassQuizAttempt(classId, quizId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JoinedClassApiApi.joinedClassApiGetClassQuizAttempt']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} classId 
         * @param {string} quizId 
         * @param {string} submissionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async joinedClassApiGetClassQuizCodeRun(classId: string, quizId: string, submissionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubmissionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.joinedClassApiGetClassQuizCodeRun(classId, quizId, submissionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JoinedClassApiApi.joinedClassApiGetClassQuizCodeRun']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} classId 
         * @param {string} quizId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async joinedClassApiGetClassQuizMarks(classId: string, quizId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClassQuizMarksResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.joinedClassApiGetClassQuizMarks(classId, quizId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JoinedClassApiApi.joinedClassApiGetClassQuizMarks']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} classId 
         * @param {string} quizId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async joinedClassApiGetClassQuizPaper(classId: string, quizId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClassQuizPaperResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.joinedClassApiGetClassQuizPaper(classId, quizId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JoinedClassApiApi.joinedClassApiGetClassQuizPaper']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} classId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async joinedClassApiGetJoinedClass(classId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JoinedClassResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.joinedClassApiGetJoinedClass(classId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JoinedClassApiApi.joinedClassApiGetJoinedClass']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} classId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async joinedClassApiGetMyClassInsights(classId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MyInsightsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.joinedClassApiGetMyClassInsights(classId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JoinedClassApiApi.joinedClassApiGetMyClassInsights']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} courseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async joinedClassApiGetMyCourse(courseId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StudentCourseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.joinedClassApiGetMyCourse(courseId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JoinedClassApiApi.joinedClassApiGetMyCourse']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} classId 
         * @param {string} quizId 
         * @param {File} answerSheet 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async joinedClassApiHandInClassQuizSheet(classId: string, quizId: string, answerSheet: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HandInAnswerSheetResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.joinedClassApiHandInClassQuizSheet(classId, quizId, answerSheet, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JoinedClassApiApi.joinedClassApiHandInClassQuizSheet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} classId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async joinedClassApiListClassMarks(classId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClassMarksResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.joinedClassApiListClassMarks(classId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JoinedClassApiApi.joinedClassApiListClassMarks']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} classId 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async joinedClassApiListJoinedClassMaterials(classId: string, page?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClassMaterialsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.joinedClassApiListJoinedClassMaterials(classId, page, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JoinedClassApiApi.joinedClassApiListJoinedClassMaterials']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} classId 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async joinedClassApiListJoinedClassPosts(classId: string, page?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.joinedClassApiListJoinedClassPosts(classId, page, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JoinedClassApiApi.joinedClassApiListJoinedClassPosts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} classId 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {Array<JoinedClassApiListJoinedClassWorkPhasesEnum>} [phases] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async joinedClassApiListJoinedClassWork(classId: string, page?: number, pageSize?: number, phases?: Array<JoinedClassApiListJoinedClassWorkPhasesEnum>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClassWorkResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.joinedClassApiListJoinedClassWork(classId, page, pageSize, phases, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JoinedClassApiApi.joinedClassApiListJoinedClassWork']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async joinedClassApiListJoinedClasses(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JoinedClassesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.joinedClassApiListJoinedClasses(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JoinedClassApiApi.joinedClassApiListJoinedClasses']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} classId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async joinedClassApiListMyClassCourses(classId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetClassCoursesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.joinedClassApiListMyClassCourses(classId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JoinedClassApiApi.joinedClassApiListMyClassCourses']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async joinedClassApiListMyCourses(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StudentCoursesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.joinedClassApiListMyCourses(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JoinedClassApiApi.joinedClassApiListMyCourses']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {JoinedClassApiListTodoStatusEnum} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async joinedClassApiListTodo(page?: number, pageSize?: number, status?: JoinedClassApiListTodoStatusEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TodoResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.joinedClassApiListTodo(page, pageSize, status, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JoinedClassApiApi.joinedClassApiListTodo']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} courseId 
         * @param {string} lessonId 
         * @param {ReadCardBody} readCardBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async joinedClassApiReadMyCourseCard(courseId: string, lessonId: string, readCardBody: ReadCardBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReadCardResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.joinedClassApiReadMyCourseCard(courseId, lessonId, readCardBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JoinedClassApiApi.joinedClassApiReadMyCourseCard']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} classId 
         * @param {string} questionId 
         * @param {string} quizId 
         * @param {QuizCodeRunBody} quizCodeRunBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async joinedClassApiRunClassQuizCode(classId: string, questionId: string, quizId: string, quizCodeRunBody: QuizCodeRunBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubmissionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.joinedClassApiRunClassQuizCode(classId, questionId, quizId, quizCodeRunBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JoinedClassApiApi.joinedClassApiRunClassQuizCode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} classId 
         * @param {string} questionId 
         * @param {string} quizId 
         * @param {SaveAttemptAnswerBody} saveAttemptAnswerBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async joinedClassApiSaveClassQuizAnswer(classId: string, questionId: string, quizId: string, saveAttemptAnswerBody: SaveAttemptAnswerBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuizAttemptQuestionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.joinedClassApiSaveClassQuizAnswer(classId, questionId, quizId, saveAttemptAnswerBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JoinedClassApiApi.joinedClassApiSaveClassQuizAnswer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {RollNumberBody} rollNumberBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async joinedClassApiSetRollNumber(rollNumberBody: RollNumberBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RollNumberResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.joinedClassApiSetRollNumber(rollNumberBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JoinedClassApiApi.joinedClassApiSetRollNumber']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} classId 
         * @param {string} quizId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async joinedClassApiStartClassQuiz(classId: string, quizId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuizAttemptResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.joinedClassApiStartClassQuiz(classId, quizId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JoinedClassApiApi.joinedClassApiStartClassQuiz']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} classId 
         * @param {string} quizId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async joinedClassApiSubmitClassQuiz(classId: string, quizId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuizAttemptResultResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.joinedClassApiSubmitClassQuiz(classId, quizId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JoinedClassApiApi.joinedClassApiSubmitClassQuiz']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * JoinedClassApiApi - factory interface
 */
export const JoinedClassApiApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = JoinedClassApiApiFp(configuration)
    return {
        /**
         * 
         * @param {JoinedClassApiApiJoinedClassApiGetClassQuizAttemptRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        joinedClassApiGetClassQuizAttempt(requestParameters: JoinedClassApiApiJoinedClassApiGetClassQuizAttemptRequest, options?: RawAxiosRequestConfig): AxiosPromise<QuizAttemptResponse> {
            return localVarFp.joinedClassApiGetClassQuizAttempt(requestParameters.classId, requestParameters.quizId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JoinedClassApiApiJoinedClassApiGetClassQuizCodeRunRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        joinedClassApiGetClassQuizCodeRun(requestParameters: JoinedClassApiApiJoinedClassApiGetClassQuizCodeRunRequest, options?: RawAxiosRequestConfig): AxiosPromise<SubmissionResponse> {
            return localVarFp.joinedClassApiGetClassQuizCodeRun(requestParameters.classId, requestParameters.quizId, requestParameters.submissionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JoinedClassApiApiJoinedClassApiGetClassQuizMarksRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        joinedClassApiGetClassQuizMarks(requestParameters: JoinedClassApiApiJoinedClassApiGetClassQuizMarksRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClassQuizMarksResponse> {
            return localVarFp.joinedClassApiGetClassQuizMarks(requestParameters.classId, requestParameters.quizId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JoinedClassApiApiJoinedClassApiGetClassQuizPaperRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        joinedClassApiGetClassQuizPaper(requestParameters: JoinedClassApiApiJoinedClassApiGetClassQuizPaperRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClassQuizPaperResponse> {
            return localVarFp.joinedClassApiGetClassQuizPaper(requestParameters.classId, requestParameters.quizId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JoinedClassApiApiJoinedClassApiGetJoinedClassRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        joinedClassApiGetJoinedClass(requestParameters: JoinedClassApiApiJoinedClassApiGetJoinedClassRequest, options?: RawAxiosRequestConfig): AxiosPromise<JoinedClassResponse> {
            return localVarFp.joinedClassApiGetJoinedClass(requestParameters.classId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JoinedClassApiApiJoinedClassApiGetMyClassInsightsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        joinedClassApiGetMyClassInsights(requestParameters: JoinedClassApiApiJoinedClassApiGetMyClassInsightsRequest, options?: RawAxiosRequestConfig): AxiosPromise<MyInsightsResponse> {
            return localVarFp.joinedClassApiGetMyClassInsights(requestParameters.classId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JoinedClassApiApiJoinedClassApiGetMyCourseRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        joinedClassApiGetMyCourse(requestParameters: JoinedClassApiApiJoinedClassApiGetMyCourseRequest, options?: RawAxiosRequestConfig): AxiosPromise<StudentCourseResponse> {
            return localVarFp.joinedClassApiGetMyCourse(requestParameters.courseId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JoinedClassApiApiJoinedClassApiHandInClassQuizSheetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        joinedClassApiHandInClassQuizSheet(requestParameters: JoinedClassApiApiJoinedClassApiHandInClassQuizSheetRequest, options?: RawAxiosRequestConfig): AxiosPromise<HandInAnswerSheetResponse> {
            return localVarFp.joinedClassApiHandInClassQuizSheet(requestParameters.classId, requestParameters.quizId, requestParameters.answerSheet, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JoinedClassApiApiJoinedClassApiListClassMarksRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        joinedClassApiListClassMarks(requestParameters: JoinedClassApiApiJoinedClassApiListClassMarksRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClassMarksResponse> {
            return localVarFp.joinedClassApiListClassMarks(requestParameters.classId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JoinedClassApiApiJoinedClassApiListJoinedClassMaterialsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        joinedClassApiListJoinedClassMaterials(requestParameters: JoinedClassApiApiJoinedClassApiListJoinedClassMaterialsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClassMaterialsResponse> {
            return localVarFp.joinedClassApiListJoinedClassMaterials(requestParameters.classId, requestParameters.page, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JoinedClassApiApiJoinedClassApiListJoinedClassPostsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        joinedClassApiListJoinedClassPosts(requestParameters: JoinedClassApiApiJoinedClassApiListJoinedClassPostsRequest, options?: RawAxiosRequestConfig): AxiosPromise<PostsResponse> {
            return localVarFp.joinedClassApiListJoinedClassPosts(requestParameters.classId, requestParameters.page, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JoinedClassApiApiJoinedClassApiListJoinedClassWorkRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        joinedClassApiListJoinedClassWork(requestParameters: JoinedClassApiApiJoinedClassApiListJoinedClassWorkRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClassWorkResponse> {
            return localVarFp.joinedClassApiListJoinedClassWork(requestParameters.classId, requestParameters.page, requestParameters.pageSize, requestParameters.phases, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        joinedClassApiListJoinedClasses(options?: RawAxiosRequestConfig): AxiosPromise<JoinedClassesResponse> {
            return localVarFp.joinedClassApiListJoinedClasses(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JoinedClassApiApiJoinedClassApiListMyClassCoursesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        joinedClassApiListMyClassCourses(requestParameters: JoinedClassApiApiJoinedClassApiListMyClassCoursesRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetClassCoursesResponse> {
            return localVarFp.joinedClassApiListMyClassCourses(requestParameters.classId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        joinedClassApiListMyCourses(options?: RawAxiosRequestConfig): AxiosPromise<StudentCoursesResponse> {
            return localVarFp.joinedClassApiListMyCourses(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JoinedClassApiApiJoinedClassApiListTodoRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        joinedClassApiListTodo(requestParameters: JoinedClassApiApiJoinedClassApiListTodoRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<TodoResponse> {
            return localVarFp.joinedClassApiListTodo(requestParameters.page, requestParameters.pageSize, requestParameters.status, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JoinedClassApiApiJoinedClassApiReadMyCourseCardRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        joinedClassApiReadMyCourseCard(requestParameters: JoinedClassApiApiJoinedClassApiReadMyCourseCardRequest, options?: RawAxiosRequestConfig): AxiosPromise<ReadCardResponse> {
            return localVarFp.joinedClassApiReadMyCourseCard(requestParameters.courseId, requestParameters.lessonId, requestParameters.readCardBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JoinedClassApiApiJoinedClassApiRunClassQuizCodeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        joinedClassApiRunClassQuizCode(requestParameters: JoinedClassApiApiJoinedClassApiRunClassQuizCodeRequest, options?: RawAxiosRequestConfig): AxiosPromise<SubmissionResponse> {
            return localVarFp.joinedClassApiRunClassQuizCode(requestParameters.classId, requestParameters.questionId, requestParameters.quizId, requestParameters.quizCodeRunBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JoinedClassApiApiJoinedClassApiSaveClassQuizAnswerRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        joinedClassApiSaveClassQuizAnswer(requestParameters: JoinedClassApiApiJoinedClassApiSaveClassQuizAnswerRequest, options?: RawAxiosRequestConfig): AxiosPromise<QuizAttemptQuestionResponse> {
            return localVarFp.joinedClassApiSaveClassQuizAnswer(requestParameters.classId, requestParameters.questionId, requestParameters.quizId, requestParameters.saveAttemptAnswerBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JoinedClassApiApiJoinedClassApiSetRollNumberRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        joinedClassApiSetRollNumber(requestParameters: JoinedClassApiApiJoinedClassApiSetRollNumberRequest, options?: RawAxiosRequestConfig): AxiosPromise<RollNumberResponse> {
            return localVarFp.joinedClassApiSetRollNumber(requestParameters.rollNumberBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JoinedClassApiApiJoinedClassApiStartClassQuizRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        joinedClassApiStartClassQuiz(requestParameters: JoinedClassApiApiJoinedClassApiStartClassQuizRequest, options?: RawAxiosRequestConfig): AxiosPromise<QuizAttemptResponse> {
            return localVarFp.joinedClassApiStartClassQuiz(requestParameters.classId, requestParameters.quizId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JoinedClassApiApiJoinedClassApiSubmitClassQuizRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        joinedClassApiSubmitClassQuiz(requestParameters: JoinedClassApiApiJoinedClassApiSubmitClassQuizRequest, options?: RawAxiosRequestConfig): AxiosPromise<QuizAttemptResultResponse> {
            return localVarFp.joinedClassApiSubmitClassQuiz(requestParameters.classId, requestParameters.quizId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for joinedClassApiGetClassQuizAttempt operation in JoinedClassApiApi.
 */
export interface JoinedClassApiApiJoinedClassApiGetClassQuizAttemptRequest {
    readonly classId: string

    readonly quizId: string
}

/**
 * Request parameters for joinedClassApiGetClassQuizCodeRun operation in JoinedClassApiApi.
 */
export interface JoinedClassApiApiJoinedClassApiGetClassQuizCodeRunRequest {
    readonly classId: string

    readonly quizId: string

    readonly submissionId: string
}

/**
 * Request parameters for joinedClassApiGetClassQuizMarks operation in JoinedClassApiApi.
 */
export interface JoinedClassApiApiJoinedClassApiGetClassQuizMarksRequest {
    readonly classId: string

    readonly quizId: string
}

/**
 * Request parameters for joinedClassApiGetClassQuizPaper operation in JoinedClassApiApi.
 */
export interface JoinedClassApiApiJoinedClassApiGetClassQuizPaperRequest {
    readonly classId: string

    readonly quizId: string
}

/**
 * Request parameters for joinedClassApiGetJoinedClass operation in JoinedClassApiApi.
 */
export interface JoinedClassApiApiJoinedClassApiGetJoinedClassRequest {
    readonly classId: string
}

/**
 * Request parameters for joinedClassApiGetMyClassInsights operation in JoinedClassApiApi.
 */
export interface JoinedClassApiApiJoinedClassApiGetMyClassInsightsRequest {
    readonly classId: string
}

/**
 * Request parameters for joinedClassApiGetMyCourse operation in JoinedClassApiApi.
 */
export interface JoinedClassApiApiJoinedClassApiGetMyCourseRequest {
    readonly courseId: string
}

/**
 * Request parameters for joinedClassApiHandInClassQuizSheet operation in JoinedClassApiApi.
 */
export interface JoinedClassApiApiJoinedClassApiHandInClassQuizSheetRequest {
    readonly classId: string

    readonly quizId: string

    readonly answerSheet: File
}

/**
 * Request parameters for joinedClassApiListClassMarks operation in JoinedClassApiApi.
 */
export interface JoinedClassApiApiJoinedClassApiListClassMarksRequest {
    readonly classId: string
}

/**
 * Request parameters for joinedClassApiListJoinedClassMaterials operation in JoinedClassApiApi.
 */
export interface JoinedClassApiApiJoinedClassApiListJoinedClassMaterialsRequest {
    readonly classId: string

    readonly page?: number

    readonly pageSize?: number
}

/**
 * Request parameters for joinedClassApiListJoinedClassPosts operation in JoinedClassApiApi.
 */
export interface JoinedClassApiApiJoinedClassApiListJoinedClassPostsRequest {
    readonly classId: string

    readonly page?: number

    readonly pageSize?: number
}

/**
 * Request parameters for joinedClassApiListJoinedClassWork operation in JoinedClassApiApi.
 */
export interface JoinedClassApiApiJoinedClassApiListJoinedClassWorkRequest {
    readonly classId: string

    readonly page?: number

    readonly pageSize?: number

    readonly phases?: Array<JoinedClassApiListJoinedClassWorkPhasesEnum>
}

/**
 * Request parameters for joinedClassApiListMyClassCourses operation in JoinedClassApiApi.
 */
export interface JoinedClassApiApiJoinedClassApiListMyClassCoursesRequest {
    readonly classId: string
}

/**
 * Request parameters for joinedClassApiListTodo operation in JoinedClassApiApi.
 */
export interface JoinedClassApiApiJoinedClassApiListTodoRequest {
    readonly page?: number

    readonly pageSize?: number

    readonly status?: JoinedClassApiListTodoStatusEnum
}

/**
 * Request parameters for joinedClassApiReadMyCourseCard operation in JoinedClassApiApi.
 */
export interface JoinedClassApiApiJoinedClassApiReadMyCourseCardRequest {
    readonly courseId: string

    readonly lessonId: string

    readonly readCardBody: ReadCardBody
}

/**
 * Request parameters for joinedClassApiRunClassQuizCode operation in JoinedClassApiApi.
 */
export interface JoinedClassApiApiJoinedClassApiRunClassQuizCodeRequest {
    readonly classId: string

    readonly questionId: string

    readonly quizId: string

    readonly quizCodeRunBody: QuizCodeRunBody
}

/**
 * Request parameters for joinedClassApiSaveClassQuizAnswer operation in JoinedClassApiApi.
 */
export interface JoinedClassApiApiJoinedClassApiSaveClassQuizAnswerRequest {
    readonly classId: string

    readonly questionId: string

    readonly quizId: string

    readonly saveAttemptAnswerBody: SaveAttemptAnswerBody
}

/**
 * Request parameters for joinedClassApiSetRollNumber operation in JoinedClassApiApi.
 */
export interface JoinedClassApiApiJoinedClassApiSetRollNumberRequest {
    readonly rollNumberBody: RollNumberBody
}

/**
 * Request parameters for joinedClassApiStartClassQuiz operation in JoinedClassApiApi.
 */
export interface JoinedClassApiApiJoinedClassApiStartClassQuizRequest {
    readonly classId: string

    readonly quizId: string
}

/**
 * Request parameters for joinedClassApiSubmitClassQuiz operation in JoinedClassApiApi.
 */
export interface JoinedClassApiApiJoinedClassApiSubmitClassQuizRequest {
    readonly classId: string

    readonly quizId: string
}

/**
 * JoinedClassApiApi - object-oriented interface
 */
export class JoinedClassApiApi extends BaseAPI {
    /**
     * 
     * @param {JoinedClassApiApiJoinedClassApiGetClassQuizAttemptRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public joinedClassApiGetClassQuizAttempt(requestParameters: JoinedClassApiApiJoinedClassApiGetClassQuizAttemptRequest, options?: RawAxiosRequestConfig) {
        return JoinedClassApiApiFp(this.configuration).joinedClassApiGetClassQuizAttempt(requestParameters.classId, requestParameters.quizId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JoinedClassApiApiJoinedClassApiGetClassQuizCodeRunRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public joinedClassApiGetClassQuizCodeRun(requestParameters: JoinedClassApiApiJoinedClassApiGetClassQuizCodeRunRequest, options?: RawAxiosRequestConfig) {
        return JoinedClassApiApiFp(this.configuration).joinedClassApiGetClassQuizCodeRun(requestParameters.classId, requestParameters.quizId, requestParameters.submissionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JoinedClassApiApiJoinedClassApiGetClassQuizMarksRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public joinedClassApiGetClassQuizMarks(requestParameters: JoinedClassApiApiJoinedClassApiGetClassQuizMarksRequest, options?: RawAxiosRequestConfig) {
        return JoinedClassApiApiFp(this.configuration).joinedClassApiGetClassQuizMarks(requestParameters.classId, requestParameters.quizId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JoinedClassApiApiJoinedClassApiGetClassQuizPaperRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public joinedClassApiGetClassQuizPaper(requestParameters: JoinedClassApiApiJoinedClassApiGetClassQuizPaperRequest, options?: RawAxiosRequestConfig) {
        return JoinedClassApiApiFp(this.configuration).joinedClassApiGetClassQuizPaper(requestParameters.classId, requestParameters.quizId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JoinedClassApiApiJoinedClassApiGetJoinedClassRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public joinedClassApiGetJoinedClass(requestParameters: JoinedClassApiApiJoinedClassApiGetJoinedClassRequest, options?: RawAxiosRequestConfig) {
        return JoinedClassApiApiFp(this.configuration).joinedClassApiGetJoinedClass(requestParameters.classId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JoinedClassApiApiJoinedClassApiGetMyClassInsightsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public joinedClassApiGetMyClassInsights(requestParameters: JoinedClassApiApiJoinedClassApiGetMyClassInsightsRequest, options?: RawAxiosRequestConfig) {
        return JoinedClassApiApiFp(this.configuration).joinedClassApiGetMyClassInsights(requestParameters.classId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JoinedClassApiApiJoinedClassApiGetMyCourseRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public joinedClassApiGetMyCourse(requestParameters: JoinedClassApiApiJoinedClassApiGetMyCourseRequest, options?: RawAxiosRequestConfig) {
        return JoinedClassApiApiFp(this.configuration).joinedClassApiGetMyCourse(requestParameters.courseId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JoinedClassApiApiJoinedClassApiHandInClassQuizSheetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public joinedClassApiHandInClassQuizSheet(requestParameters: JoinedClassApiApiJoinedClassApiHandInClassQuizSheetRequest, options?: RawAxiosRequestConfig) {
        return JoinedClassApiApiFp(this.configuration).joinedClassApiHandInClassQuizSheet(requestParameters.classId, requestParameters.quizId, requestParameters.answerSheet, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JoinedClassApiApiJoinedClassApiListClassMarksRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public joinedClassApiListClassMarks(requestParameters: JoinedClassApiApiJoinedClassApiListClassMarksRequest, options?: RawAxiosRequestConfig) {
        return JoinedClassApiApiFp(this.configuration).joinedClassApiListClassMarks(requestParameters.classId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JoinedClassApiApiJoinedClassApiListJoinedClassMaterialsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public joinedClassApiListJoinedClassMaterials(requestParameters: JoinedClassApiApiJoinedClassApiListJoinedClassMaterialsRequest, options?: RawAxiosRequestConfig) {
        return JoinedClassApiApiFp(this.configuration).joinedClassApiListJoinedClassMaterials(requestParameters.classId, requestParameters.page, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JoinedClassApiApiJoinedClassApiListJoinedClassPostsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public joinedClassApiListJoinedClassPosts(requestParameters: JoinedClassApiApiJoinedClassApiListJoinedClassPostsRequest, options?: RawAxiosRequestConfig) {
        return JoinedClassApiApiFp(this.configuration).joinedClassApiListJoinedClassPosts(requestParameters.classId, requestParameters.page, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JoinedClassApiApiJoinedClassApiListJoinedClassWorkRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public joinedClassApiListJoinedClassWork(requestParameters: JoinedClassApiApiJoinedClassApiListJoinedClassWorkRequest, options?: RawAxiosRequestConfig) {
        return JoinedClassApiApiFp(this.configuration).joinedClassApiListJoinedClassWork(requestParameters.classId, requestParameters.page, requestParameters.pageSize, requestParameters.phases, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public joinedClassApiListJoinedClasses(options?: RawAxiosRequestConfig) {
        return JoinedClassApiApiFp(this.configuration).joinedClassApiListJoinedClasses(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JoinedClassApiApiJoinedClassApiListMyClassCoursesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public joinedClassApiListMyClassCourses(requestParameters: JoinedClassApiApiJoinedClassApiListMyClassCoursesRequest, options?: RawAxiosRequestConfig) {
        return JoinedClassApiApiFp(this.configuration).joinedClassApiListMyClassCourses(requestParameters.classId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public joinedClassApiListMyCourses(options?: RawAxiosRequestConfig) {
        return JoinedClassApiApiFp(this.configuration).joinedClassApiListMyCourses(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JoinedClassApiApiJoinedClassApiListTodoRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public joinedClassApiListTodo(requestParameters: JoinedClassApiApiJoinedClassApiListTodoRequest = {}, options?: RawAxiosRequestConfig) {
        return JoinedClassApiApiFp(this.configuration).joinedClassApiListTodo(requestParameters.page, requestParameters.pageSize, requestParameters.status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JoinedClassApiApiJoinedClassApiReadMyCourseCardRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public joinedClassApiReadMyCourseCard(requestParameters: JoinedClassApiApiJoinedClassApiReadMyCourseCardRequest, options?: RawAxiosRequestConfig) {
        return JoinedClassApiApiFp(this.configuration).joinedClassApiReadMyCourseCard(requestParameters.courseId, requestParameters.lessonId, requestParameters.readCardBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JoinedClassApiApiJoinedClassApiRunClassQuizCodeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public joinedClassApiRunClassQuizCode(requestParameters: JoinedClassApiApiJoinedClassApiRunClassQuizCodeRequest, options?: RawAxiosRequestConfig) {
        return JoinedClassApiApiFp(this.configuration).joinedClassApiRunClassQuizCode(requestParameters.classId, requestParameters.questionId, requestParameters.quizId, requestParameters.quizCodeRunBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JoinedClassApiApiJoinedClassApiSaveClassQuizAnswerRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public joinedClassApiSaveClassQuizAnswer(requestParameters: JoinedClassApiApiJoinedClassApiSaveClassQuizAnswerRequest, options?: RawAxiosRequestConfig) {
        return JoinedClassApiApiFp(this.configuration).joinedClassApiSaveClassQuizAnswer(requestParameters.classId, requestParameters.questionId, requestParameters.quizId, requestParameters.saveAttemptAnswerBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JoinedClassApiApiJoinedClassApiSetRollNumberRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public joinedClassApiSetRollNumber(requestParameters: JoinedClassApiApiJoinedClassApiSetRollNumberRequest, options?: RawAxiosRequestConfig) {
        return JoinedClassApiApiFp(this.configuration).joinedClassApiSetRollNumber(requestParameters.rollNumberBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JoinedClassApiApiJoinedClassApiStartClassQuizRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public joinedClassApiStartClassQuiz(requestParameters: JoinedClassApiApiJoinedClassApiStartClassQuizRequest, options?: RawAxiosRequestConfig) {
        return JoinedClassApiApiFp(this.configuration).joinedClassApiStartClassQuiz(requestParameters.classId, requestParameters.quizId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JoinedClassApiApiJoinedClassApiSubmitClassQuizRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public joinedClassApiSubmitClassQuiz(requestParameters: JoinedClassApiApiJoinedClassApiSubmitClassQuizRequest, options?: RawAxiosRequestConfig) {
        return JoinedClassApiApiFp(this.configuration).joinedClassApiSubmitClassQuiz(requestParameters.classId, requestParameters.quizId, options).then((request) => request(this.axios, this.basePath));
    }
}

export const JoinedClassApiListJoinedClassWorkPhasesEnum = {
    Open: 'open',
    Scheduled: 'scheduled',
    Closed: 'closed',
} as const;
export type JoinedClassApiListJoinedClassWorkPhasesEnum = typeof JoinedClassApiListJoinedClassWorkPhasesEnum[keyof typeof JoinedClassApiListJoinedClassWorkPhasesEnum];
export const JoinedClassApiListTodoStatusEnum = {
    Assigned: 'assigned',
    Missing: 'missing',
    Done: 'done',
} as const;
export type JoinedClassApiListTodoStatusEnum = typeof JoinedClassApiListTodoStatusEnum[keyof typeof JoinedClassApiListTodoStatusEnum];
